if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    init() {

      const remainingCents = Number(this.getAttribute('data-free-shipping')) || 0;
      const thresholdCents = Number(this.getAttribute('data-threshold')) || 0;
      const showBar        = this.hasAttribute('data-progress-bar');
      const locales        = window.KROWN.settings.locales;

      // Fuellstand 0-100 % (Anteil der Schwelle, der bereits im Warenkorb liegt)
      let progress = 0;
      if (thresholdCents > 0) {
        progress = Math.round(((thresholdCents - remainingCents) / thresholdCents) * 100);
        progress = Math.min(100, Math.max(0, progress));
      }

      const success = remainingCents <= 0;

      // Text waehlen: erreicht -> fast geschafft (optional) -> Standard
      let message = '';
      if (success) {
        message = locales.shipping_notice_eligible_for_free;
      } else {
        const remainingText = this._formatMoney(remainingCents, KROWN.settings.shop_money_format);
        const almostPercent = Number(this.getAttribute('data-almost-percent')) || 75;
        const almostText    = locales.shipping_notice_almost_free || '';

        if (showBar && almostText.trim() !== '' && almostText.indexOf('Translation missing') === -1 && progress >= almostPercent) {
          message = almostText.replace('{{ remaining_amount }}', remainingText);
        } else {
          message = locales.shipping_notice_remaining_to_free.replace('{{ remaining_amount }}', remainingText);
        }
      }

      // Fortschrittsbalken (nur wenn per Theme-Einstellung aktiviert)
      let barHtml = '';
      if (showBar) {
        const fillColor  = success
          ? (this.getAttribute('data-bar-success-color') || '#007600')
          : (this.getAttribute('data-bar-color') || '#C08A3E');
        const trackColor = this.getAttribute('data-bar-track-color') || '#e3e0dc';
        const fillWidth  = success ? 100 : Math.max(progress, 2);

        barHtml = `
          <div class="shipping-notice__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${progress}" style="margin-top:8px;height:9px;border-radius:5px;overflow:hidden;background:${trackColor};">
            <div style="width:${fillWidth}%;height:100%;border-radius:5px;background:${fillColor};transition:width .4s ease;"></div>
          </div>`;
      }

            let iconHtml = '';
      if (showBar) {
        iconHtml = success
          ? `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" style="flex-shrink:0;"><circle cx="12" cy="12" r="10"></circle><path d="M8 12.5l2.6 2.6L16 9.5"></path></svg>`
          : `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" style="flex-shrink:0;"><path d="M1 6h13v11H1z"></path><path d="M14 10h5l3 3v4h-8"></path><circle cx="6" cy="19" r="1.8"></circle><circle cx="18" cy="19" r="1.8"></circle></svg>`;
      }

      if ( this.hasAttribute('data-show-alert') ) {
        this.innerHTML = `
          <div class="alert alert--wide alert--${success ? 'success' : 'note'}">
            <div style="width:100%;min-width:0;">
              <div style="display:flex;align-items:center;gap:9px;">${iconHtml}<span>${message}</span></div>
              ${barHtml}
            </div>
          </div>`;
      } else {
        this.innerHTML = message + barHtml;
      }

    }

    _formatMoney(cents, format) {

      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }

      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          '$1' + thousands
        );
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);

    }

  }

  if ( typeof customElements.get('shipping-notice') == 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}